import { createReducer, on } from '@ngrx/store'
import { resetLpisKulturas, setLpisKulturas } from './lpis-kultura.actions'
import { LpisKultura } from '../../../api/backend'

const INIT_STATE: ILpisKulturasState = {
    lpisKulturas: []
}

export const lpisKulturaReducer = createReducer(
    INIT_STATE,
    on(setLpisKulturas, (state, { data }): ILpisKulturasState => (
        {...state, lpisKulturas: data}
    )),
    on(resetLpisKulturas, (): ILpisKulturasState => INIT_STATE),
)

export interface ILpisKulturasState {
    lpisKulturas: LpisKultura[];
}